import styled from 'styled-components';

const StyledPageHeader = styled.h1`
  ${({theme}) => `
    margin: 25px;
    color: ${theme.palette.primary.main};
  `}
`;

export { StyledPageHeader };